import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { StatusRepository } from '../../../infrastructure/repositories/status.repository';
import { StatusState } from '../../states/status.state';
import { GetStatusCategoriesResult } from './get-status-categories.result';

@Injectable()
export class GetStatusCategoriesUseCase {
  private readonly repository = inject(StatusRepository);
  private readonly state = inject(StatusState);

  execute(): Observable<GetStatusCategoriesResult> {
    this.state.setCategoriesLoading(true);
    this.state.clearCategoriesError();

    return this.repository.getCategories().pipe(
      tap((categories) => {
        this.state.setCategories(categories);
      }),
      map((categories) => ({ categories })),
      catchError((error) => {
        this.state.setCategoriesError(error.message || 'Failed to load categories');
        throw error;
      }),
      finalize(() => {
        this.state.setCategoriesLoading(false);
      }),
    );
  }
}
